import React, { useContext, useState, useEffect } from 'react'
import Layout from 'components/layout'
import SEO from 'components/seo'
import { injectIntl } from 'gatsby-plugin-intl'
import { graphql } from 'gatsby'
import BusinessCase from '../components/businessCase'
import styled from 'styled-components'
import { colors, breakpoints } from 'utils/utils'
import { GlobalStateContext } from '../context/globalContext'
import { GlobalDispatchContext } from '../context/globalContext'
import BusinessCaseForm from '../components/businessCaseForm'

export default injectIntl( props => {
    const { seo, title, businessCase, form } = props.data.contentfulSection

    // This flag is to delete the empty form used to register bucases form in netlify
    const [flag, setFlag] = useState(false)
    const changeFlag = () => {
        setFlag(true);
    }

    const state = useContext(GlobalStateContext)
    const dispatch = useContext(GlobalDispatchContext)  
     
    useEffect(() => {
        if(state.otherLanguageSlug !== props.pageContext.otherLanguageSlug) {
            dispatch(state.changeOtherLanguageSlug(props.pageContext.otherLanguageSlug))
        }
    }, [state, dispatch, props.pageContext.otherLanguageSlug])
    
    return (    
        <Layout>
            <SEO 
                title={seo.title}
                keywords={seo.attributes[0].keywords}
                slug={seo.slug}
                description={seo.attributes[0].description}
                lang={props.pageContext.language}
            />
            <Container>
                <Title>{title}</Title>                
                <Grid>
                    {
                        businessCase.map((bcase, index) => 
                            <BusinessCase key={index} data={bcase} form={form} lang={props.pageContext.language} changeFlag={changeFlag}/>
                        )
                    }
                </Grid>
                {
                    !flag &&
                    <div className="hidden">
                        <BusinessCaseForm data={{}} form={form} lang={props.pageContext.language} close={changeFlag}/>
                    </div>
                }
            </Container>
        </Layout>
    )
})

const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 7rem 4vw 3rem;
    background-color: ${colors.primary};
    color: ${colors.quinary};
    ${breakpoints.md} {
        padding: 7rem 7vw 3rem;
    }
`

const Title = styled.h1`
    margin-bottom: 3rem;
    text-transform: uppercase;
`

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1.5vw;

    ${breakpoints.lg} {
        // grid-template-columns: repeat(2, 1fr);
        grid-template-columns: 1fr;

    }

    // ${breakpoints.sm} {
    //     grid-template-columns: 1fr;
    // }

    > .bcase {
        width: 100%;
        height: 13vw;
        ${breakpoints.lg} {
            height: 30vw;
        }
        ${breakpoints.md} {
            height: 35vw;
        }
    }
`

export const query = graphql`
    query($language: String) {
        contentfulSection(name: {eq: "Business Cases"}, node_locale: {eq: $language}) {
            id
            title
            seo {
                title
                slug
                attributes {
                    description
                    keywords
                }
            }
            businessCase {
                name
                subtitle
                description {
                    description
                }
                background {
                    fluid {
                        ...GatsbyContentfulFluid
                    }
                }
                pdf {
                    file {
                        url
                        fileName
                    }
                }
            }
            form {
                formTextField {
                    id
                    htmlid
                    type
                    label
                    required
                }
                disclaimer {
                    id
                    htmlid
                    text {
                        text
                    }
                    required
                }
                errorMessage
                successMessage
                button
            }
        }
    }
`